import {
    DownOutlined,
    IdcardOutlined
} from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import { Button, Form, message, Select } from 'antd';
import { UserApiService } from 'features/users';
import {
    AddEventFormField,
    AddEventFormValues
} from 'features/users/components/users-filter-form';
import { useCreteEventAcessAgentRole } from 'features/users/use-cases/create-event-access';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const { getcommonDropDownAgent } = UserApiService();

type EventListType = {
    Id: string;
    Text: string;
    Value: string;
    initial: any
};

export const AddAgentEventModal = ({ agentId, agentId_, onClose, eventRefetch, initialAcess }: any) => {
    const formName = 'add-event-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<AddEventFormValues>();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const [eventList, setEventList] = useState<EventListType[]>([]);
    const { isLoading, mutate } = useCreteEventAcessAgentRole();

    const handleClose = () => {
        onClose();
        form.resetFields();
        eventRefetch();
    };

    const getInitialValues = {
        [AddEventFormField.EventName]: undefined
    };

    // Load Event List
    const EventList = async () => {
        try {
            const apiRes: any = await getcommonDropDownAgent(`Flag=${'EventListForAgent'}`);
            setEventList(apiRes.dropDownList);

        } catch (error) {
            message.error("Failed to load events");
        }
    };
    useEffect(() => {
        EventList();
    }, []);

    // FINAL SUBMIT — CORRECT PAYLOAD
    const handleUpdate = (formData: AddEventFormValues) => {
        const selectedEvents: any = formData.event_id; // [{label, value}, ...]

        const eventIds = selectedEvents.map((e: any) => e.value).join(",");

        const payload: any = {
            AgentId: agentId,
            EventIds: eventIds
        };

        mutate(payload, {
            onSuccess: (data:any) => {
                handleClose();
                initialAcess(); // refetch
                queryClient.invalidateQueries(['agentEventList', agentId_]);
                if(data?.ResponseStatus==0){

                    message.error(data?.ResponsMessage)
                }else{
                    message.success(data?.ResponsMessage)
                }
            },
            onError: () => {
                message.error("Failed to update events");
            },
        });
    };


    return (
        <div className="popup">
            <div className="modal_head">
                <button onClick={handleClose} className="close-btn">
                    &times;
                </button>
                <h4>Events</h4>
            </div>

            <div className="modal_body">
                <Form<AddEventFormValues>
                    id={formName}
                    name={formName}
                    form={form}
                    layout="vertical"
                    initialValues={getInitialValues}
                    onFinish={handleUpdate}
                    onFinishFailed={() => setValidateTrigger(['onChange'])}
                    validateTrigger={validateTrigger}
                    disabled={isLoading}
                >
                    {/* EVENT LIST DROPDOWN */}
                    {/* <Form.Item
                        name={AddEventFormField.EventName}
                        label="Event Master"
                        rules={[{ required: true }]}
                    >
                        <Select
                            options={eventList.map((res: any) => ({
                                label: res.Text,
                                value: res.Id
                            }))}
                            placeholder={t('volunteer.field.assign_event.placeholder')}
                            className="has-prefix-icon"
                            labelInValue
                            mode="multiple"  // FIXED
                            suffixIcon={
                                <>
                                    <IdcardOutlined className="prefix-icon" />
                                    <DownOutlined className="suffix-icon" />
                                </>
                            }
                        />
                    </Form.Item> */}
                    <Form.Item
                        name={AddEventFormField.EventName}
                        label="Event Master"
                        rules={[{ required: true }]}
                    >
                        <Select
                            mode="multiple"
                            labelInValue
                            showSearch   // ✅ enables search bar
                            placeholder={t('volunteer.field.assign_event.placeholder')}
                            className="has-prefix-icon"
                            suffixIcon={
                                <>
                                    <IdcardOutlined className="prefix-icon" />
                                    <DownOutlined className="suffix-icon" />
                                </>
                            }
                            options={eventList.map((res: any) => ({
                                label: res.Name,
                                value: res.Id
                            }))}

                            // 🔍 Enable searching by label
                            filterOption={(input, option) =>
                                (option?.label ?? '')
                                    .toString()
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>


                    {/* BUTTON */}
                    <div className="form-button">
                        <Button type="primary" htmlType="submit" className="btn">
                            Save
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};
